import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';

@Component({
    selector: 'ms-banner-tick',
    templateUrl: 'banner-tick.html',
    standalone: true,
})
export class BannerTickComponent implements OnChanges, OnInit {
    @Input() model: number;
    value: number;
    newValue: number;
    private classList = ['animate', 'new-tick', 'old-tick'];
    @ViewChild('numberClone', { static: true }) numberClone: ElementRef;
    @ViewChild('number', { static: true }) number: ElementRef;
    private container1: any;
    private container2: any;

    ngOnInit(): void {
        this.container1 = this.number.nativeElement;
        this.container2 = this.numberClone.nativeElement;

        this.animate();
    }

    ngOnChanges(changes: SimpleChanges): void {
        const change = changes['model'];

        if (!change) {
            return;
        }

        this.newValue = change.currentValue;

        if (change.firstChange) {
            return;
        }

        this.animate();
    }

    private animate(): void {
        if (this.value !== this.newValue) {
            this.animateCounterPart();
            this.value = this.newValue;
        }
    }

    private animateCounterPart(): void {
        this.removeClasses(this.container1, this.classList);
        this.removeClasses(this.container2, this.classList);

        this.container1.innerHTML = this.newValue.toString();
        this.container1.classList.add('new-tick');

        this.container2.classList.add('old-tick');
        this.container2.classList.add('animate');

        const t = this.container1;
        this.container1 = this.container2;
        this.container2 = t;
    }

    private removeClasses(element: Element, classes: string[]): void {
        for (const _class of classes) {
            element.classList.remove(_class);
        }
    }
}
